import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Plan } from "../models";
import { useData } from "../utils/useData";
import { AcceptedServicesList } from "./AcceptedServicesList";
import { AccountCard } from "./AccountCard";
import { SectionHeader } from "./SectionHeader";

export const AccountsList = () => {
  const { plans, employee } = useData();
  const [selectedPlanIndex, setSelectedPlanIndex] = useState(0);
  const [serviceSectorNames, setServiceSectorNames] = useState<string[]>();

  const getDistinctServiceSectorNames = (plan: Plan): string[] => {
    const allNames = plan?.serviceSectors?.map((sector) => sector.name);
    const distinctNamesSet = new Set(allNames);
    return Array.from(distinctNamesSet);
  };

  const handlePlanSelect = () => {
    if (!employee.data?.accounts[selectedPlanIndex]) return;
    let selectedPlan = plans.data?.items.find(
      (p) => p.id === employee.data?.accounts[selectedPlanIndex].planId
    );
    if (!selectedPlan) return;
    setServiceSectorNames(getDistinctServiceSectorNames(selectedPlan));
  };

  useEffect(() => {
    if (!employee.data || !plans.data) return;
    handlePlanSelect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPlanIndex, employee.data, plans.data]);

  return (
    <>
      <Box>
        {employee.data?.accounts.map((a, i) => {
          return (
            <Box key={i} onClick={() => setSelectedPlanIndex(i)} my={2}>
              <AccountCard account={a} isSelected={selectedPlanIndex === i} />
            </Box>
          );
        })}
      </Box>
      <Box mt={3}>
        <SectionHeader text="Use with the following" />
        <Typography variant="body2">
          Your HealthNow card is accepted at all businesses that take
          Mastercard/debit cards and offer the following services:
        </Typography>
        <AcceptedServicesList serviceSectors={serviceSectorNames} />
      </Box>
    </>
  );
};
